export default __webpack_public_path__ + "static/media/axnLogo.00e26047.svg";